import React from 'react';
import { Helmet } from 'react-helmet-async';

const DEFAULT_DESC =
  'Bespoke Print MIS solutions tailored to your business. Imprint specializes in system integration, workflow automation, and management information systems for the print and packaging industry.';
const DEFAULT_IMAGE = 'https://imprint-mis.co.uk/og-image.jpg';
const SITE_NAME = 'Imprint MIS';
const DEFAULT_TITLE = 'Imprint MIS - Integration and Print & Packaging MIS Specialists';

/**
 * Per-page SEO + Open Graph metadata.
 * Falls back to sensible defaults if a field is omitted.
 */
const SEO = ({
  title,
  description = DEFAULT_DESC,
  image = DEFAULT_IMAGE,
  url,
  type = 'website',
  publishedTime,
  modifiedTime,
}) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;
  const canonical = url || (typeof window !== 'undefined' ? window.location.href : '');

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {canonical && <link rel="canonical" href={canonical} />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={SITE_NAME} />
      {canonical && <meta property="og:url" content={canonical} />}
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
